import React, { useEffect, useRef, useState } from "react";
import { Bars, Circles } from "react-loader-spinner";
import nodata from "../../Assets/Image/admin/nodata.png";
import add from "../../Assets/Image/admin/add.png";
import { useNavigate } from "react-router-dom";
import Dialog from "../../Base-Component/Dialog/Dialog";
import edit from "../../Assets/Image/admin/edit.png";
import {
  addLanguage,
  getLanguage,
  updateLanguage,
} from "../../Services/ApiServices";
import toast from "react-hot-toast";
import Cookies from "js-cookie";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Switch } from "@headlessui/react";

function Language() {
  const navigate = useNavigate();
  const scrollRef = useRef(null);

  const [isDragging, setIsDragging] = useState(false);
  const [loader, setLoader] = useState(false);
  const [isAddLanguage, setIsAddLanguage] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);

  const [totalPage, setTotalPage] = useState("1");
  const [languageId, setLanguageId] = useState("");

  const [pageNo, setPageNo] = useState(1);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);

  const [languageName, setLanguageName] = useState({});
  const [switchStates, setSwitchStates] = useState({});
  const [userData, setUserData] = useState([]);

  const handleUserList = () => {
    setLoader(true);
    let obj = {
      page: pageNo,
    };
    getLanguage(obj)
      .then((res) => {
        const data = res.data.data;
        setUserData(data);
        setTotalPage(res.data.totalPages);
        setLoader(false);
      })
      .catch((err) => {
        if (err.response.status == 401) {
          Cookies.remove("e_learning_token");
          navigate("/login");
        } else {
          toast.error(err.response.data.message);
        }
        setLoader(false);
      });
  };

  useEffect(() => {
    handleUserList();
  }, [pageNo]);

  useEffect(() => {
    const initialStates = {};
    userData.forEach((item) => {
      initialStates[item.id] = item.is_active; // Set switch state from API response
    });
    setSwitchStates(initialStates);
  }, [userData]);

  const startDragging = (e) => {
    setIsDragging(true);
    setStartX(e.pageX - scrollRef.current.offsetLeft);
    setScrollLeft(scrollRef.current.scrollLeft);
    document.body.style.userSelect = "none";
  };

  const stopDragging = () => {
    setIsDragging(false);
    document.body.style.userSelect = "";
  };

  const onDragging = (e) => {
    if (!isDragging) return;
    e.preventDefault();
    const x = e.pageX - scrollRef.current.offsetLeft;
    const walk = (x - startX) * 2;
    scrollRef.current.scrollLeft = scrollLeft - walk;
  };

  const renderPaginationButtonss = () => {
    const maxPagesToShow = 3;
    const buttons = [];
    const startPage = Math.max(1, pageNo - Math.floor(maxPagesToShow / 2));
    const endPage = Math.min(totalPage, startPage + maxPagesToShow - 1);

    for (let i = startPage; i <= endPage; i++) {
      buttons.push(
        <button
          key={i}
          onClick={() => handlePageChange(i)}
          className={
            i === pageNo
              ? "px-4 py-[7px] mx-1 bg-[#EA5F5F1A] rounded-md text-[#EA5F5F]"
              : "px-4 py-[7px] mx-1 text-[#EA5F5F]"
          }
        >
          {i}
        </button>
      );
    }
    return buttons;
  };

  const handlePageChange = (page) => {
    if (page > 0 && page <= totalPage) {
      setPageNo(page);
    }
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      languageName: isUpdate && languageName ? languageName : "",
    },
    validationSchema: Yup.object({
      languageName: Yup.string()
        .trim()
        .required("Language Name is required")
        .matches(/.*\S.*/, "Language Name cannot be just spaces")
        .max(30, "Must be 30 characters or less"),
    }),
    onSubmit: (values) => {
      console.log(values);
      setIsLoading(true);
      if (isUpdate) {
        let obj = {
          Language_name: values.languageName,
          language_id: languageId,
        };
        updateLanguage(obj)
          .then((res) => {
            toast.success(res.data.message);
            setIsAddLanguage(false);
            handleUserList();
          })
          .catch((err) => {
            if (err.response.status == 401) {
              Cookies.remove("e_learning_token");
              navigate("/login");
            } else {
              toast.error(err.response.data.message);
            }
            setIsLoading(false);
          });
      } else {
        let obj = {
          Language_name: values.languageName,
        };
        addLanguage(obj)
          .then((res) => {
            toast.success(res.data.message);
            setIsAddLanguage(false);
            handleUserList();
          })
          .catch((err) => {
            if (err.response.status == 401) {
              Cookies.remove("e_learning_token");
              navigate("/login");
            } else {
              toast.error(err.response.data.message);
            }
            setIsLoading(false);
          });
      }
    },
  });

  const handleAdd = () => {
    setIsAddLanguage(true);
    setIsUpdate(false);
    setLanguageName("");
    setIsLoading(false);
  };

  const handleEdite = (data) => {
    setIsAddLanguage(true);
    setLanguageName(data.Language_name);
    setLanguageId(data.id);
    setIsUpdate(true);
    setIsLoading(false);
  };

  const handleSwitch = (id, currentState) => {
    const newState = !currentState;
    let obj = {
      language_id: id,
      status: newState == true ? "1" : "0",
    };
    updateLanguage(obj)
      .then((res) => {
        setSwitchStates((prev) => ({
          ...prev,
          [id]: newState,
        }));
      })
      .catch((err) => {
        if (err.response.status == 401) {
          Cookies.remove("e_learning_token");
          navigate("/login");
        } else {
          toast.error(err.response.data.message);
        }
        setIsLoading(false);
      });
  };
  return (
    <div className="md:m-4 m-1 fontNew">
      <div className="flex sm:flex-nowrap flex-wrap justify-end mb-7">
        <div className="flex sm:flex-nowrap flex-wrap-reverse items-center justify-end sm:w-auto w-full">
          <div>
            <button
              onClick={handleAdd}
              className="bg-[#e29c29] text-white flex items-center py-2 px-3 sm:mb-0 mb-3 rounded-lg whitespace-nowrap"
            >
              <img src={add} className="w-6 mr-2" alt="" />
              Add Language
            </button>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-12">
        {loader ? (
          <div className="flex justify-center items-center col-span-12 h-[70vh]">
            <Bars
              height="35"
              width="35"
              color="#e29c29"
              ariaLabel="bars-loading"
              wrapperStyle={{}}
              wrapperClass=""
              visible={true}
            />
          </div>
        ) : (
          <>
            {userData.length === 0 ? (
              <div className="col-span-12 h-[50vh] justify-center flex items-center">
                <img src={nodata} className="w-28" alt="No data" />
              </div>
            ) : (
              <>
                <div className="col-span-12">
                  <div
                    className="w-full lg:overflow-hidden overflow-auto"
                    onMouseDown={startDragging}
                    onMouseLeave={stopDragging}
                    onMouseUp={stopDragging}
                    onMouseMove={onDragging}
                    ref={scrollRef}
                  >
                    <table className="w-full border-separate border-spacing-y-3">
                      <thead>
                        <tr className="bg-white">
                          <th className="py-4 px-7 text-base font-medium whitespace-nowrap text-start first:rounded-l-lg last:rounded-r-lg">
                            <h4>LANGUAGE ID</h4>
                          </th>
                          <th className="py-4 px-2 text-base font-medium whitespace-nowrap text-start first:rounded-l-lg last:rounded-r-lg">
                            <h4>LANGUAGE NAME</h4>
                          </th>
                          <th className="py-4 px-2 text-base font-medium whitespace-nowrap text-start first:rounded-l-lg last:rounded-r-lg">
                            <div className="text-center">
                              <h4>ACTION</h4>
                            </div>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {userData.map((item, index) => {
                          return (
                            <tr key={index} className="font-medium bg-white">
                              <td className="text-start px-7 py-3 first:rounded-l-lg last:rounded-r-lg">
                                <div className="whitespace-nowrap">
                                  {item.id}
                                </div>
                              </td>
                              <td className="text-start lg:px-2 px-4 py-3 first:rounded-l-lg last:rounded-r-lg">
                                <div className="whitespace-nowrap">
                                  <p className="text-base truncate w-[250px]">
                                    {item.Language_name || ""}
                                  </p>
                                </div>
                              </td>
                              <td className="text-start flex justify-center lg:px-2 px-4 py-3 first:rounded-l-lg last:rounded-r-lg">
                                <div className="flex items-center w-52 justify-center">
                                  <div
                                    className="mr-4 cursor-pointer"
                                    onClick={() => handleEdite(item)}
                                  >
                                    <img
                                      src={edit}
                                      className="lg:w-9 w-8"
                                      alt="Delete"
                                    />
                                  </div>
                                  <div>
                                    <Switch
                                      checked={switchStates[item.id] ?? false}
                                      onChange={() =>
                                        handleSwitch(
                                          item.id,
                                          switchStates[item.id] ?? false
                                        )
                                      }
                                      className="group relative flex h-7 w-14 cursor-pointer rounded-full bg-gray-300 p-1 transition-colors duration-200 ease-in-out focus:outline-none data-[focus]:outline-1 data-[focus]:outline-white data-[checked]:bg-[#00987C]"
                                    >
                                      <span
                                        aria-hidden="true"
                                        className="pointer-events-none inline-block size-5 translate-x-0 rounded-full bg-white ring-0 shadow-lg transition duration-200 ease-in-out group-data-[checked]:translate-x-7"
                                      />
                                    </Switch>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className="col-span-12 flex flex-wrap items-center sm:justify-end justify-center bg-white py-4 sm:px-8 px-0 rounded-lg">
                  <div className="flex items-center cursor-pointer">
                    <p
                      onClick={() => handlePageChange(pageNo - 1)}
                      disabled={pageNo === 1}
                    >
                      Previous
                    </p>
                    <div className="flex items-center mx-6">
                      {renderPaginationButtonss()}
                    </div>
                    <p
                      onClick={() => handlePageChange(pageNo + 1)}
                      disabled={pageNo === totalPage}
                    >
                      Next
                    </p>
                  </div>
                </div>
              </>
            )}
          </>
        )}
      </div>

      <Dialog
        open={isAddLanguage}
        onClose={() => setIsAddLanguage(false)}
        size="md"
      >
        <Dialog.Panel>
          <Dialog.Description className="rounded-none border-2 border-white">
            <div className="p-4 sm:w-auto w-[330px] h-auto overflow-auto fontNew">
              <h4 className="text-lg font-semibold mb-2">Add Language</h4>
              <form onSubmit={formik.handleSubmit}>
                <div className="grid grid-cols-12 ">
                  <div className="col-span-12 md:mx-2 mx-0 my-5">
                    <h4 className="text-sm font-medium mb-3">Language Name</h4>
                    <input
                      type="text"
                      name="languageName"
                      value={formik.values.languageName}
                      onChange={formik.handleChange}
                      maxLength={30}
                      className="border-2 px-4 py-3 rounded-md w-full outline-[#e1c595]"
                      placeholder="Enter"
                    />
                    {formik.touched.languageName &&
                    formik.errors.languageName ? (
                      <div className="text-red-500 text-sm mt-2">
                        ({formik.errors.languageName})
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className="mt-6 flex justify-end">
                  <button
                    type="button"
                    onClick={() => setIsAddLanguage(false)}
                    className="bg-[#EF5F5F] py-2 px-7 text-white rounded-lg mr-5"
                  >
                    Close
                  </button>
                  <button
                    type="submit"
                    disabled={formik.isSubmitting || isLoading}
                    className="bg-[#00987C] text-white h-[50px] w-30 rounded-lg"
                  >
                    {isLoading ? (
                      <div className="flex justify-center">
                        <Circles
                          width={25}
                          height={25}
                          color="#fff"
                          ariaLabel="circles-loading"
                          wrapperStyle={{}}
                          visible={true}
                          wrapperClass=""
                        />
                      </div>
                    ) : (
                      `${isUpdate ? "Update" : "Add"}`
                    )}
                  </button>
                </div>
              </form>
            </div>
          </Dialog.Description>
        </Dialog.Panel>
      </Dialog>

      <Dialog open={isDelete} onClose={() => setIsDelete(false)} size="2xl">
        <Dialog.Panel>
          <Dialog.Description className="rounded-none border-2 border-white">
            <div className="flex justify-center text-center my-4 sm:px-16 px-4 fontNew">
              <div>
                <h4 className="text-xl font-semibold text-black mt-6">
                  Delete Weblink?
                </h4>
                <p className="text-sm text-gray-500 my-3">
                  Are you sure you want to delete this Weblink?
                </p>
                <div className="mt-13 flex items-center mb-5">
                  <button
                    className="bg-[#F4F5FA] h-[50px] sm:w-36 w-30 text-sm rounded-xl sm:mx-3 mx-2"
                    onClick={() => setIsDelete(false)}
                  >
                    Close
                  </button>
                  <button
                    className="bg-[#e29c29] h-[50px] sm:w-36 w-30 text-sm rounded-xl sm:mx-3 mx-2 text-white"
                    onClick={() => setIsDelete(false)}
                  >
                    {isLoading ? (
                      <div className="flex justify-center">
                        <Circles
                          width={25}
                          height={25}
                          color="#fff"
                          ariaLabel="circles-loading"
                          wrapperStyle={{}}
                          visible={true}
                          wrapperClass=""
                        />
                      </div>
                    ) : (
                      "Yes, Delete"
                    )}
                  </button>
                </div>
              </div>
            </div>
          </Dialog.Description>
        </Dialog.Panel>
      </Dialog>
    </div>
  );
}

export default Language;
